import { useCallback, useEffect, useState } from 'react';
import { BiCtaNames } from '../../../../../bi/types';
import { HTTP_PREFIX } from '../../../../../consts';
import { useBiLogger } from '../../../../../hooks/use-bi-logger';
import { originalImageUrl } from '../../../../../utils/resolve-image-url';
import { calculateOrientation, getImageMetadata } from './image-size';
const IMAGE_SIZE = 32;
export const useImageSize = (url, isOpen) => {
  const biLogger = useBiLogger();
  const enlargedImageUrl = useCallback(() => url.startsWith(HTTP_PREFIX) ? url : originalImageUrl(url), [url]);
  const [enlargedImageSize, setEnlargedImageSize] = useState({
    height: 0,
    orientation: null,
    width: 0
  });
  const [enlargeImage, setEnlargeImage] = useState({
    isImageEnlarged: false,
    minimizedImageHeight: IMAGE_SIZE,
    minimizedImageWidth: IMAGE_SIZE,
    url
  });
  const handleImageSize = (index, status, event) => {
    if (isOpen) {
      event == null || event.stopPropagation();
      if (enlargeImage.isImageEnlarged) {
        biLogger.taskElementCtaClick({
          ctaName: BiCtaNames.MinimizeImage,
          index,
          status
        });
        setEnlargeImage({
          ...enlargeImage,
          isImageEnlarged: false
        });
      } else {
        biLogger.taskElementCtaClick({
          ctaName: BiCtaNames.EnlargeImage,
          index,
          status
        });
        setEnlargeImage({
          ...enlargeImage,
          isImageEnlarged: true
        });
      }
    }
  };
  useEffect(() => {
    const getImageData = async () => {
      const {
        dimensions
      } = await getImageMetadata(enlargedImageUrl());
      const orientation = calculateOrientation(dimensions);
      setEnlargedImageSize({
        height: dimensions.height,
        orientation,
        width: dimensions.width
      });
    };
    getImageData();
  }, [enlargedImageUrl, url]);
  return {
    enlargeImage,
    enlargedImageSize,
    handleImageSize,
    setEnlargeImage
  };
};
//# sourceMappingURL=use-image-size.js.map